import React from "react";

import { ScrollArea, Table, createStyles } from "@mantine/core";

import { useState } from "react";
import { useSelector } from "react-redux";
import FacilityTypeTableRow from "../FacilityTypeTableRow";
import RecordNotFound from "../RecordNotFound";
import TableLoader from "../TableLoader";

const useStyles = createStyles((theme) => ({
  header: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    borderRadius: "16px",
    transition: "box-shadow 150ms ease",
    "& th": {
      backgroundColor: "var(--app-surface)",
      color: "var(--app-text) !important",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
    },
  },
  tbl: {
    borderRadius: ".5rem !important",
    borderCollapse: "separate",
    overflow: "hidden",
  },
  scrolled: {
    boxShadow: theme.shadows.sm,
  },
  notFoundText: {
    color: "var(--app-text-muted)",
    fontFamily: "Inter",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
  },
}));

const FacilityTable = ({ data }) => {
  const { loading, facilityTypes } = useSelector((state) => state.facility);
  const { classes, cx } = useStyles();
  const [scrolled, setScrolled] = useState(false);

  const rows = facilityTypes?.ftypes?.map((row, i) => (
    <FacilityTypeTableRow key={i} row={{ ...row, type: row?.name }} index={i} />
  ));

  return (
    <ScrollArea
      onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
      sx={{ marginTop: "30px" }}
    >
      <Table
        // withColumnBorders
        withBorder
        highlightOnHover
        enableStickyHeader
        sx={{ fontFamily: "Inter" }}
        fontSize={"sm"}
        verticalSpacing={"md"}
        className={classes.tbl}
      >
        <thead className={cx(classes.header, { [classes.scrolled]: scrolled })}>
          <tr>
            <th>Facility Type</th>
            <th style={{ minWidth: "50px" }}></th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <TableLoader />
          ) : rows?.length ? (
            rows
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-evenly",
                height: "100vh",
                gap: "8rem"
              }}
            >
              <RecordNotFound />
              <p className={classes.notFoundText}>
                You don&apos;t have any record, click on “Add New Facility Type”
              </p>
            </div>
          )}
        </tbody>
      </Table>
    </ScrollArea>
  );
};

export default FacilityTable;
